import styled from 'styled-components';

const PaginationContainer = styled.div`
  display: flex;
`;

export default PaginationContainer;
